<template>
  <div>
    <label class="checkbox">
      <button :class="checkboxClass" @click="selectItem">
        <i class="mdi mdi-check"></i>
      </button>
      {{ option.label }}
    </label>
  </div>
</template>

<script>
export default {
  name: `YogaCheckbox`,

  props: {
    option: Object,
    config: String,
    single: Boolean,
  },
  computed: {
    exportOption() {
      return { ...this.option, config: this.config };
    },
    checkboxClass() {
      if (this.option.selected) {
        return `checkbox-input checkbox-input-selected`;
      }
      return `checkbox-input`;
    },
  },

  methods: {
    selectItem() {
      if (this.single !== false) {
        this.singleSelect();
      } else {
        this.multiSelect();
      }
    },

    multiSelect() {
      if (this.option.selected === false) {
        this.option.selected = true;
        this.$store.dispatch(`selectOption`, this.exportOption);
      } else {
        this.option.selected = false;
        this.$store.dispatch(`selectOption`, this.exportOption);
      }
    },

    singleSelect() {
      if (this.option.selected === false) {
        this.option.selected = true;
        this.$store.dispatch(`selectSingleOption`, this.exportOption);
      } else {
        this.option.selected = false;
        this.$store.dispatch(`selectSingleOption`, this.exportOption);
      }
    },
  },
};
</script>

<style lang="scss">
$purple: #656b85;
$black: #191919;
$white: #ffffff;

.checkbox {
  font-size: 18px;
  color: $purple;
  font-weight: 300;
  display: inline-block;
  min-width: 150px;
  margin-left: 25px;
  margin-top: 15px;
  .checkbox-input {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 1px solid $purple;
    background-color: transparent;
    position: relative;
    color: $white;
    transition: background-color 300ms ease;
    .mdi {
      position: absolute;
      top: -6px;
      left: 0;
      width: 18px;
      height: 18px;
      opacity: 0;
      font-size: 19px;
      transition: opacity 300ms ease;
    }
    &:focus {
      outline: transparent;
    }
  }

  .checkbox-input-selected {
    background-color: $purple;
    .mdi {
      opacity: 1;
    }
  }
}
</style>
